import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'commaToDot'
})
export class CommaToDotPipe implements PipeTransform {

  transform(value: string, args?: any): any {
    return value.replace(new RegExp(',', 'g'), '.');
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/comma-to-dot.pipe.ts